import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgProviderIconSecondary from './svgs/ProviderIconSecondary.js';
import SvgProviderIcon from './svgs/ProviderIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var providerIcon = (props => useIcon(SvgProviderIcon, SvgProviderIconSecondary, props));

export { providerIcon as default };
